globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Public = appCustomerSpace.Modals.Public || {};

appCustomerSpace.Modals.Public.LeadGeneration = (function(superClass) {

  utils.extend(LeadGeneration, superClass);

  function LeadGeneration($html) {
    this.$html           = $html;
    this.$content        = $html.find(".modal-content");
    this.$body           = $html.find(".modal-body");

    return LeadGeneration.__super__.constructor.apply(this, arguments);
  }

  $.extend(LeadGeneration.prototype, {
    callbackSuccess: function(data, successMsg) {
      var modal = this;

      if(data && data.response == 1) {
        modal.$body.append(data.html);
        appCustomerSpace.Loader().stop();
      } else {
        appCustomerSpace.Loader().stop();
        appCustomerSpace.Loader().error({ $container: modal.$body, options: { style: { backdrop: { background: "#FFF" } }, error: { persisted: true } } });
      }
    }
  });

  return LeadGeneration;

})(appCustomerSpace.Modal);
